<template>
  <Navbar />
  <div class="course-detail-view">
    <div v-if="loading" class="loading-container">
      <a-spin size="large" />
      <p>{{ t("common.loading") }}...</p>
    </div>

    <div v-else-if="error" class="error-container">
      <a-alert :message="error" type="error" />
      <a-button type="primary" @click="retry" class="retry-button">{{
        t("common.retry")
      }}</a-button>
    </div>

    <CourseDetail v-else :course-id="courseId" />
  </div>
  <FooterSection />
</template>
  
  <script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import CourseDetail from "../components/CourseDetail.vue";
import Navbar from "@/components/Navbar.vue";
import FooterSection from "@/components/FooterSection.vue";

const { t } = useI18n();

const route = useRoute();
const loading = ref(true);
const error = ref(null);

const courseId = computed(() => route.params.id || "");

// 初始加載
onMounted(async () => {
  if (!courseId.value) {
    error.value = t("courseDetail.courseIdNotFound");
    loading.value = false;
    return;
  }

  // 簡單初始化延遲
  setTimeout(() => {
    loading.value = false;
  }, 1000);
});

// 重試函數
const retry = () => {
  loading.value = true;
  error.value = null;

  // 簡單的重試邏輯
  setTimeout(() => {
    loading.value = false;
  }, 1000);
};
</script>
  
  <style scoped>
.course-detail-view {
  min-height: 80vh;
}

.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  text-align: center;
}

.retry-button {
  margin-top: 20px;
}
</style>